import { ImmutableStore } from 'fluxible-immutable-utils';
import Actions from '../constants/Actions';

const defaultState = {
  // holds count of total number of events that meet current filtering criteria
  count: 0,
  // holds current page of events
  events: null,
  eventsLoading: true,
  error: null
};

class AuditDashboardStore extends ImmutableStore {

  static storeName = 'AuditDashboardStore';

  static handlers = {
    [Actions.AUDIT_DASHBOARD__DATA_QUERY_STARTED]: 'clearAuditData',
    [Actions.AUDIT_DASHBOARD__DATA_QUERY_COMPLETED]: 'setAuditData',
    [Actions.AUDIT_DASHBOARD__DATA_QUERY_FAILED]: 'setToError'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.setState(defaultState);
  }

  clearAuditData() {
    this.mergeState({
      count: defaultState.count,
      events: defaultState.events,
      eventsLoading: defaultState.eventsLoading
    });
  }

  getStateData() {
    return this.getState().toJS();
  }

  setAuditData({ count, events }) {
    this.mergeState({
      count,
      events,
      eventsLoading: false,
      error: null
    });
  }

  setToError() {
    this.mergeState({
      ...defaultState,
      error: 'Failed to load audit data'
    });
  }

  rehydrate(state) {
    state._state.events.forEach((event) => {
      event.timestamp = new Date(event.timestamp);
    });
    super.rehydrate(state._state);
  }
}

export default AuditDashboardStore;



// WEBPACK FOOTER //
// ./src/stores/AuditDashboardStore.js